export default __webpack_public_path__ + "static/media/kidScreen.c39f09a7.png";